import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e69414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middle" }
const _hoisted_2 = { class: "group-list-sim-card pb-5" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "sim-card-compartment" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "My eSims", -1))
const _hoisted_6 = { class: "button-toggle-group mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon app-d" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Account management ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "tarif-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__label" }, "Delete my account", -1))
const _hoisted_15 = { class: "profile-row-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__btn--label" }, " Your account will be permanently deleted ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile__label" }, "Promotional materials", -1))
const _hoisted_19 = { class: "checkbox-group" }
const _hoisted_20 = { for: "check" }

import EsimCard from "@/components/esim/EsimCard.vue";
import { EsimType, useEsimStore } from "@/stores/esim";
import { onMounted, Ref, ref, watch } from "vue";
import { useUserStore } from "@/stores/user";
import MainLoader from "@/components/MainLoader.vue";
import { useAppStore } from "@/stores/app";
import PopupDeleteAccount from "@/components/popups/PopupDeleteAccount.vue";
import router from "@/router";
import { useBundleStore } from "@/stores/bundle";
import { copyToClipBoard } from "@/helpers";
import PopupDevices from "@/components/popups/PopupDevices.vue";
import InfoIcon from "@/components/icons/InfoIcon.vue";
import PopupPromoTerms from "@/components/popups/PopupPromoTerms.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const esimStore = useEsimStore();
const userStore = useUserStore();
const appStore = useAppStore();
const bundleStore = useBundleStore();

const esimsLoading: Ref<boolean> = ref(false);
const esimType: Ref<EsimType> = ref(EsimType.active);
const deletePressed: Ref<boolean> = ref(false);
const managementOpened: Ref<boolean> = ref(false);

async function getEsims() {
  esimsLoading.value = true;
  await esimStore.getEsims(esimType.value, true);
  esimsLoading.value = false;
}

function onDeleteClick() {
  if (deletePressed.value) {
    appStore.showPopup({ component: PopupDeleteAccount });
    deletePressed.value = false;
  } else {
    deletePressed.value = true;
  }
}

const goSearch = (): void => {
  bundleStore.clearBundles();
  router.push("/");
};

onMounted(getEsims);
watch(esimType, getEsims);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["button-toggle", { active: esimType.value === _unref(EsimType).active }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (esimType.value = _unref(EsimType).active)),
              disabled: esimsLoading.value
            }, " Active ", 10, _hoisted_7),
            _createElementVNode("button", {
              class: _normalizeClass(["button-toggle", { active: esimType.value === _unref(EsimType).archive }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (esimType.value = _unref(EsimType).archive)),
              disabled: esimsLoading.value
            }, " Archive ", 10, _hoisted_8)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(esimStore).esimsByType(esimType.value), (esim) => {
            return (_openBlock(), _createBlock(EsimCard, {
              key: esim.id,
              esim: esim
            }, null, 8, ["esim"]))
          }), 128)),
          (esimsLoading.value && !_unref(esimStore).esimsByType(esimType.value).length)
            ? (_openBlock(), _createBlock(MainLoader, {
                key: 0,
                primary: ""
              }))
            : (!_unref(esimStore).esimsByType(esimType.value).length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " You have no eSIM eSIM will be shown here after purchase "))
              : _createCommentVNode("", true),
          (!_unref(esimStore).esimsByType(esimType.value).length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-b btn-danger profile__buy",
                onClick: goSearch
              }, [
                _hoisted_10,
                _createTextVNode("Buy an eSIM ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["description-tarif-content-item", { active: managementOpened.value }]),
          style: {"border":"none","padding":"0"}
        }, [
          _createElementVNode("h6", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (managementOpened.value = !managementOpened.value))
          }, _hoisted_12),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-b btn-default profile__btn", { pressed: deletePressed.value }]),
                onClick: onDeleteClick,
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (deletePressed.value = false))
              }, _toDisplayString(deletePressed.value ? "Click again" : "Delete account"), 35),
              _hoisted_16
            ]),
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(userStore).promoSubscribed) = $event)),
                type: "checkbox",
                id: "check"
              }, null, 512), [
                [_vModelCheckbox, _unref(userStore).promoSubscribed]
              ]),
              _createElementVNode("label", _hoisted_20, [
                _createElementVNode("span", null, [
                  _createTextVNode(" Inform me about new promotions and tips. "),
                  _createElementVNode("button", {
                    class: "button-link",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
                      _unref(appStore).showPopup({ component: PopupPromoTerms })
                    ), ["prevent"]))
                  }, " Read more ")
                ])
              ])
            ])
          ])
        ], 2),
        _createElementVNode("button", {
          class: "btn btn-b btn-default mt-5",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(userStore).logout && _unref(userStore).logout(...args)))
        }, " Log out ")
      ])
    ])
  ]))
}
}

})